import { Card, Steps } from 'antd';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ButtonTheme, ModalTheme, RenderForm, TextSmall } from '../../../../components';
import { ContainerButton } from '../../../../styles/global-style';
import { FORM_TEXTAREA, FORM_TRANSFER_TELEPHONE } from '../forms';
import { color } from '../../../../resources';
import { useAntDModalContext } from '../../../../components/modal/context/useAntdModalContext';
import { useTransferVerify } from '../hooks/useTransferVerify';
import { useTransferUpdate } from '../hooks/useTransferUpdate';

export const TransferTelephone = ({ open, onToggle, initialValues, onCloseAll, onFetch }) => {
  const { control, setValue, getValues, handleSubmit } = useForm();
  const { Step } = Steps;
  const [current, setCurrent] = useState(0);
  const { openConfirmModal } = useAntDModalContext();
  const { mutate: onTransferVerify } = useTransferVerify();
  const { mutate: onTransferUpdate } = useTransferUpdate({
    onSuccessCallBack: onFetch,
  });

  const next = () => {
    onTransferVerify(
      {
        oldTelephone: initialValues?.telephone,
        newTelephone: getValues('newTelephone'),
      },
      {
        onSuccess: () => {
          setCurrent(current + 1);
        },
      },
    );
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: 'กรอกเบอร์ใหม่',
      content: (
        <>
          <TextSmall color={color.red}>*กรณีที่เบอร์เหมือนกันเท่านั้น</TextSmall>
          <RenderForm
            control={control}
            forms={FORM_TRANSFER_TELEPHONE()}
            setValue={setValue}
            getValues={getValues}
          />
        </>
      ),
    },
    {
      title: 'ตรวจสอบข้อมูลโอนย้าย',
      content: (
        <>
          <TextSmall color={color.red}>
            *เมื่อโอนย้ายข้อมูลแล้วข้อมูลการลงทะเบียน, เคลม จะถูกย้ายไปรวมกับเบอร์ใหม่ทั้งหมด
          </TextSmall>
          <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
            <Card title="ข้อมูลปัจจุบัน" bordered style={{ width: '50%' }}>
              <p>รหัสลูกค้า : {initialValues?.customerCode || '-'}</p>
              <p>เบอร์ : {initialValues?.telephone || '-'}</p>
              <p>ชื่อ - สกุล : {initialValues?.fullName || '-'}</p>
            </Card>
            <Card title="เบอร์ใหม่ที่ต้องการโอนย้ายไป" bordered style={{ width: '50%' }}>
              <p>รหัสลูกค้า : {initialValues?.customerCode || '-'}</p>
              <p>เบอร์ : {getValues('newTelephone') || '-'}</p>
              <p>ชื่อ - สกุล : {initialValues?.fullName || '-'}</p>
            </Card>
          </div>
          <div style={{ marginTop: 16 }}>
            <RenderForm
              control={control}
              forms={FORM_TEXTAREA()}
              setValue={setValue}
              getValues={getValues}
            />
          </div>
        </>
      ),
    },
  ];

  const onSubmit = () => {
    openConfirmModal({
      title: 'โปรดยืนยัน',
      content: 'คุณต้องการโอนย้ายข้อมูลนี้ใช่หรือไม่',
      onOk: () => {
        onTransferUpdate({
          oldTelephone: initialValues?.telephone,
          newTelephone: getValues('newTelephone'),
          remark: getValues('remark'),
        },
          {
            onSuccess: () => {
              onCloseAll();
            },
          });
      },
    });
  };

  useEffect(() => {
    if (!initialValues) {
      return;
    }
    setValue('oldTelephone', initialValues?.telephone);
  }, [setValue, initialValues]);

  console.log(initialValues);

  return (
    <ModalTheme title="โอนย้ายข้อมูล" open={open} onToggle={onToggle} width={600}>
      <Steps current={current}>
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <div style={{ marginTop: 24 }}>
        {steps[current].content}
      </div>
      <ContainerButton right>
        {current > 0 && (
          <ButtonTheme useFor="BACK" onClick={prev} />
        )}
        {current < steps.length - 1 && (
          <ButtonTheme useFor="CHECK" style={{ backgroundColor: color.orangeTheme }} onClick={handleSubmit(next)} />
        )}
        {current === steps.length - 1 && (
          <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        )}
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};